import { jsxs as m, Fragment as c, jsx as o } from "react/jsx-runtime";
import { c as i } from "../../../index-Cu0xwYjD.js";
import { forwardRef as d } from "react";
import { LabelText as n } from "../LabelText/LabelText.js";
import { r as p } from "../../../Radio.module-CyeURz5J.js";
import '../../../assets/RadioCard.css';const f = "_card_m54on_4", l = {
  card: f
}, _ = d(
  ({ id: t, label: r, className: a = !0, ...s }, e) => /* @__PURE__ */ m(c, { children: [
    /* @__PURE__ */ o(
      "input",
      {
        id: t,
        ref: e,
        type: "radio",
        className: p.radioInput,
        ...s
      }
    ),
    /* @__PURE__ */ o("label", { htmlFor: t, className: i(l.card, a), children: typeof r == "string" ? /* @__PURE__ */ o(n, { children: r }) : r })
  ] })
);
export {
  _ as RadioCard
};
